

export const index = 8;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/(main)/privacy/_page.svelte.js')).default;
export const universal = {
  "ssr": false
};
export const universal_id = "src/routes/(app)/(main)/privacy/+page.ts";
export const imports = ["_app/immutable/nodes/8.DcIIkoMB.js","_app/immutable/chunks/17pQV_og.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/CvggxNKg.js","_app/immutable/chunks/DXxkZ4MO.js","_app/immutable/chunks/BgXaETc1.js","_app/immutable/chunks/Cc9MKd4K.js","_app/immutable/chunks/CxGJX4YF.js","_app/immutable/chunks/R6oqabqE.js","_app/immutable/chunks/ZDu7Cnc7.js","_app/immutable/chunks/2Y1nK0y3.js","_app/immutable/chunks/Djq1yBDF.js"];
export const stylesheets = ["_app/immutable/assets/Loading.BAEB0oic.css","_app/immutable/assets/8.BAoRcaES.css"];
export const fonts = [];
